// User role enum to match backend implementation
// BASE_ROLES: 基础角色（主角色，决定身份与模块入口）
export enum UserRole {
  ADMIN = 'admin',
  FINANCE = 'finance',
  LAWYER = 'lawyer',
  STAFF = 'staff',

  // 附加角色（能力附加，只提升对应域的管理能力，不含基础权限）
  STAFF_ADMIN = 'staff_admin',      // 员工管理员：线索域管理能力
  LAWYER_ADMIN = 'lawyer_admin',    // 律师管理员：案件域管理能力
  FINANCE_ADMIN = 'finance_admin'   // 财务管理员：财务域管理能力
}

// 基础角色（可作为主角色）
export const BASE_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.FINANCE,
  UserRole.LAWYER,
  UserRole.STAFF
];

// 附加角色白名单（只能作为附加角色勾选）
export const ATTACHABLE_ROLES: UserRole[] = [
  UserRole.STAFF_ADMIN,
  UserRole.LAWYER_ADMIN,
  UserRole.FINANCE_ADMIN
];

// User status enum
export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended'
}

// Permission constants
export const PERMISSIONS = {
  // Lead permissions
  LEAD_VIEW: 'lead:view',
  LEAD_CREATE: 'lead:create',
  LEAD_EDIT: 'lead:edit',
  LEAD_DELETE: 'lead:delete',
  LEAD_CLAIM: 'lead:claim',
  LEAD_RELEASE: 'lead:release',

  // Case permissions
  CASE_VIEW: 'case:view',
  CASE_CREATE: 'case:create',
  CASE_EDIT: 'case:edit',
  CASE_DELETE: 'case:delete',
  CASE_ASSIGN: 'case:assign',

  // User management permissions
  USER_VIEW: 'user:view',
  USER_CREATE: 'user:create',
  USER_EDIT: 'user:edit',
  USER_DELETE: 'user:delete',

  // System permissions
  SYSTEM_CONFIG: 'system:config',
  SYSTEM_EXPORT: 'system:export',
  SYSTEM_IMPORT: 'system:import',

  // Admin permissions
  ADMIN_ALL: '*'
} as const;

// Helper function to check if role has admin privileges
export const isAdminRole = (role: string): boolean => {
  return role === UserRole.ADMIN;
};

// Helper function to get role display name
export const getRoleDisplayName = (role: UserRole): string => {
  const roleNames: Record<string, string> = {
    [UserRole.ADMIN]: '管理员',
    [UserRole.FINANCE]: '财务',
    [UserRole.LAWYER]: '律师',
    [UserRole.STAFF]: '员工',
    [UserRole.STAFF_ADMIN]: '员工管理员（附加）',
    [UserRole.LAWYER_ADMIN]: '律师管理员（附加）',
    [UserRole.FINANCE_ADMIN]: '财务管理员（附加）'
  };
  return roleNames[role] || role;
};

// Helper function to get status display name
export const getStatusDisplayName = (status: UserStatus): string => {
  const statusNames: Record<UserStatus, string> = {
    [UserStatus.ACTIVE]: '正常',
    [UserStatus.INACTIVE]: '停用',
    [UserStatus.SUSPENDED]: '暂停'
  };
  return statusNames[status] || status;
};